import './CountryPage.css';

export const Intake = ({ country }) => {
    return (
        <div className="main-content">
            <section className="academic-intake">
                <h2>Academic Intake to Study in { country.name }</h2>
                <p>{ country.intake.title }</p>
                <div className="table-container">
                    <table className="intake-table">
                        <thead>
                            <tr>
                                <th>Intake</th>
                                <th>Month</th>
                            </tr>
                        </thead>
                        <tbody>
                            { country.intake.intakes.map((intake) => (
                                <tr>
                                    <td>{ intake.name }</td>
                                    <td>{ intake.month }</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
    )
}